import React, { Fragment, useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import { OverlayTrigger, Tab, Tabs } from 'react-bootstrap';
import { ISearchRecord, IElasticResult } from '../../../types/search';
import { searchAIEarth } from '../../../services/firebase';
import { Spinner } from 'react-bootstrap';
import * as R from 'ramda';
import withAuthContext from '../../../context/auth/AuthConsumer';
import { IAuthContext } from '../../../context/auth/auth-context';
import { TIERS } from '../../../types/tiers';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import UserContext from '../../../context/user/user-context';
import AirAiSummary from './AirAiSummary';
import axios from 'axios';
import { CeresLogger } from '../../../logger';
import AirEventTable from './AirEventTable';
import TreeView from '../TreeViewData';
import { Col } from 'react-bootstrap';
import AirDeviationTable from './AirDeviationTable';
import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import ReactDOMServer from 'react-dom/server';
import { API_BASE_URL, API_AUTH_HEADERS } from '../../../util/api.util';
import { glassPanelBase } from '../../ui/mysites';
import { commonColors } from '../../ui/commonStyles';
interface IRecordMarkerProps {
  lat: number;
  lng: number;
  isActive: boolean;
  showDocPanel: any;
  setShowDocPanel: any;
  record: ISearchRecord;
  onMarkerClick: (record: any) => void;
  onInfoWindowClose: () => void;
  context: IAuthContext;
  isMap: boolean;
  isWaterMode?: boolean;
  currentQueryText: string;
  setRelatedDocument: any;
  setAirEventTableOpen: any;
  airEventTableOpen: any;
  setStreetView: any;
  activeTabDrawer: any;
  selectedRecordOption: string;
  setIframeUrl: any;
  relatedRecordIndex: any;
}
// const RecordMarkerInfoWindowContainer = styled.div`
//   position: absolute;
//   bottom: 30px;
//   left: -250px;
//   width: 500px;
//   background: #fff;
//   box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.3);
//   padding: 10px;
//   font-size: 14px;
//   z-index: 100;
// `;

const EntityRecordListContainer = styled.div`
  overflow-x: auto;
  border-radius: 1.25rem;
  padding: 0.35rem 1rem 1rem;
  ${glassPanelBase};

  h6 {
    margin: 0.25rem 0 0.5rem;
    color: #f8fafc;
    font-weight: 700;
  }

  a {
    color: ${commonColors.accent};
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2em 0em;
`;

const SampleFileHyperlink = styled.a`
  float: right;
  color: ${commonColors.accent} !important;
  margin-right: 0.15rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  &:hover {
    color: ${commonColors.accentHover} !important;
    text-decoration: underline !important;
  }
`;

const CustomTabs = styled(Tabs)`
  border-bottom: 1px solid rgba(148, 163, 184, 0.35) !important;
  font-size: 14px !important;
  margin-top: 0.3rem;

  .nav-tabs {
    border-bottom: 1px solid rgba(148, 163, 184, 0.28) !important;
  }

  .nav-link {
    color: ${commonColors.accent} !important;
    border: 0 !important;
    border-bottom: 2px solid transparent !important;
    background: transparent !important;
    padding: 0.45rem 0.65rem;
  }

  .nav-link.active {
    color: ${commonColors.accent} !important;
    background: transparent !important;
    border: 1px solid ${commonColors.accent} !important;
    border-bottom-color: ${commonColors.accent} !important;
    box-shadow: none !important;
  }
`;

const OLContainer = styled.ol`
  padding-inline-start: 20px !important;
  font-size: 0.7rem;
  color: ${commonColors.textPrimary};
`;

interface IProps {
  isActive?: string;
  $isWaterMode?: boolean;
}

const MarkerPin = styled.div<IProps>`
  width: 30px;
  height: 30px;
  border-radius: 50% 50% 50% 0;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  background: #005fbc;
  background: var(--primary);
  transform: rotate(-45deg)${(props) => (props.$isWaterMode ? ' scale(0.6)' : '')};
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
  cursor: pointer;
  z-index: 10;
  background: ${(props) => props.isActive};
  &:after {
    content: '';
    width: 14px;
    height: 14px;
    margin: 8px 0 0 8px;
    background: #fff;
    background: var(--light);
    position: absolute;
    border-radius: 50%;
  }
`;
const getTCEQRecordUrl = (entityNumber: string) => {
  if(!entityNumber) {
    return '#';
  }

  const href = entityNumber.toLowerCase();
  if(href.includes('rn')) {
    return `https://www15.tceq.texas.gov/crpub/index.cfm?fuseaction=regent.validateRE&re_ref_num_txt=${entityNumber}`;
  }

  return 'https://edms.deq.louisiana.gov/edmsv2/quick-search-results';
};

const fetchRecordsByRN = (rnNumber: string, searchTerm: string, searchType: string) => {
  return searchAIEarth({
    query: {
      from: 0,
      size: 50,
      text: searchTerm,
      type: searchType,
      sortByReleaseDate: true,
      terms: {
        regulated_entity_number: rnNumber,
      },
    },
  });
};

// const InfoWindowCloseContainer = styled.div`
//   position: absolute;
//   right: 10px;
//   cursor: pointer;
// `;

const DownloadHyperlink = styled.a`
  color: ${commonColors.textPrimary};
  cursor: pointer;
  &:hover {
    color: #ffffff !important;
    text-decoration: underline !important;
  }
`;
const IconPegman = styled.img`
  width: 30px;
  cursor: pointer;
  margin: 5px 0;
`;

const RecordMarkerContainer = styled.div`
  min-height: 60vh;
  color: ${commonColors.textPrimary};
`;

const EntityTitle = styled.h6`
  margin: 0;
  padding: 0.4rem 0.65rem;
  color: #f8fafc;
  font-weight: 700;
  display: block;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(160deg, rgba(8, 13, 20, 0.78) 0%, rgba(5, 10, 18, 0.74) 100%);
  border: 1px solid rgba(148, 163, 184, 0.28);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(12px);
  border-radius: 0.65rem;
`;

/**
 * check if the file needs to be downloaded from storage bucket
 * or rely on the file url, directly.
 */

const RecordMarkerInfoWindow: React.FC<{
  routerProps: RouteComponentProps<any>;
  record: ISearchRecord;
  isLoading: boolean;
  activeTabDrawer: any;
  details: any;
  relatedRecords: ISearchRecord[];
  onInfoWindowClose: () => void;
  authContext: IAuthContext;
  setShowDocPanel: any;
  setRelatedDocument: any;
  airAiResults: any;
  totalEvents: any;
  deviations: any;
  setDeviations: any;
  selectedRecordOption: string;
  setIframeUrl: any;
  relatedRecordIndex: any;
}> = (props) => {
  const documentsTabTitle = `Documents(${props.relatedRecords.length})`;
  const authContext = props.authContext;
  const record = props.record;
  const searchContext = useContext(UserContext);
  const renderSpinner = () => (
    <SpinnerContainer>
      <Spinner animation="border" variant="primary" />
    </SpinnerContainer>
  );
  const [selectedContentId, setSelectedContentId] = useState<any>();

  useEffect(() => {
    if(props.relatedRecords && props.relatedRecords.length) {
      setSelectedContentId(`${props.relatedRecords[0].contentId}_${props.relatedRecords[0].containsSearchTerm}`);
    }
  }, [props.relatedRecords]);

  const getRecordTitle = (item: ISearchRecord) => `${item.title} - ${item.seriesName} - ${item.releaseDate}`;

  useEffect(() => {
    if(props.selectedRecordOption === 'Agency Documents') {
      props.setRelatedDocument(props.relatedRecords[props.relatedRecordIndex]);
    } else if(props.selectedRecordOption === 'Permits') {
      props.setIframeUrl('https://tceq.liputra.com/entity-details.php');
    } else {
      props.setRelatedDocument('');
    }

    return () => props.setRelatedDocument('');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.relatedRecordIndex, props.selectedRecordOption, props.relatedRecords]);

  const getCurrentRecordOption = () => {
    switch(props.selectedRecordOption) {
      case 'Agency Documents':
        return (<Tab eventKey="documents" title={documentsTabTitle}>
          <OLContainer>
          {R.compose(
            R.map((relatedRecord: ISearchRecord) => {
              return (
                <li
                  style={{
                    color: relatedRecord.containsSearchTerm ? commonColors.accent : commonColors.textPrimary,
                    fontWeight: `${relatedRecord.contentId}_${relatedRecord.containsSearchTerm}` === selectedContentId ? 'bold' : 'normal'
                  }}
                  key={relatedRecord.contentId}
                >
                  {authContext.isTier(TIERS.FREE) && !authContext.isLubrizol() ? (
                    getRecordTitle(relatedRecord)
                  ) : (
                    <DownloadHyperlink
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => {
                        e.stopPropagation();
                        props.setShowDocPanel(true);
                        props.setRelatedDocument(relatedRecord);
                        setSelectedContentId(`${relatedRecord.contentId}_${relatedRecord.containsSearchTerm}`);
                      }}
                    >
                      {getRecordTitle(relatedRecord)}
                    </DownloadHyperlink>
                  )}
                </li>
              );
            }),
            R.sort(
              R.comparator(
                (itemOne: ISearchRecord, itemTwo: ISearchRecord) => itemOne.releaseDate > itemTwo.releaseDate
              )
            )
          )(props.relatedRecords)}
          </OLContainer>
        </Tab>);
      case 'Permits': {
        return (<Tab eventKey="permits" title={`Permits(${props.details ? Object.keys(props.details).length : ''})`}>
        <TreeView details={props.details} />
      </Tab>);
      }
      case 'Emission Events':
        return (props.airAiResults && props.airAiResults.length > 0 ? (
          <Tab
            eventKey="emissionEvents"
            title={`Emission Events(${props.totalEvents ? props.airAiResults.length : ''})`}
          >
            {props.totalEvents && (
              <>
                <Col lg={10} sm={12} style={{ fontSize: '14px', color: '#f8fafc' }}>
                  <span style={{ color: '#f8fafc' }}>Total events: {props.airAiResults.length} (since 2004)</span> <br />
                {!record.entityNumber.toLowerCase().includes('ldeq') &&
                  <div style={{ color: '#f8fafc' }}>
                  Total released: {props.totalEvents ? props.totalEvents.toFixed(2) : ''} lbs
                  </div>
                }
                </Col>
                <AirEventTable events={props.airAiResults} record={props.record} />
              </>
            )}
          </Tab>
        ) : null);
      case 'Deviations':
        return (props.deviations && props.deviations.length > 0 ? (
          <Tab eventKey="" title={`Deviations(${props.deviations ? Object.keys(props.deviations).length : ''})`}>
            <AirDeviationTable events={props.deviations} />
          </Tab>
        ) : null);
      default:
        return null;
      }
  };

  const renderResult = () => {
    return (
      <EntityRecordListContainer>
        <SampleFileHyperlink
          onClick={(e) => {
            e.stopPropagation();
            const ceresSearch = searchContext;
            localStorage.setItem('RnNumber', record.entityNumber);
            localStorage.setItem('searchTerm', ceresSearch.searchTerm);
            window.open('/', '_blank');
          }}
        >
          Search Entity Docs
        </SampleFileHyperlink>
        <h6>
          {authContext.isTier(TIERS.FREE) && !authContext.isLubrizol() && !record.entityNumber.toLowerCase().includes('rn') && !record.entityNumber.toLowerCase().includes('ldeq') ? (
            record.entityNumber
          ) : (
            <a target="_blank" rel="noopener noreferrer" href={getTCEQRecordUrl(record.entityNumber)}>
              {record.entityNumber}
            </a>
          )}
        </h6>
        <CustomTabs defaultActiveKey={props.activeTabDrawer} id="uncontrolled-tab-example">
          {getCurrentRecordOption()}
        </CustomTabs>
      </EntityRecordListContainer>
    );
  };
  return (
    // <RecordMarkerInfoWindowContainer>
    //   <InfoWindowCloseContainer onClick={() => props.onInfoWindowClose()}>
    //     <X />
    //   </InfoWindowCloseContainer>
    <Fragment>
      <EntityTitle>{record.entityName}</EntityTitle>
      {props.isLoading && renderSpinner()}
      {!props.isLoading && renderResult()}
    </Fragment>
    // </RecordMarkerInfoWindowContainer>
  );
};

const MyTundraRecordMarker: React.FC<IRecordMarkerProps & RouteComponentProps<any>> = (props) => {
  const [details, setDetails] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [relatedRecords, setRelatedRecords] = useState<ISearchRecord[]>([]);
  const entityNumber = props.record.entityNumber;
  const authContext = props.context;
  const { isMap } = props;
  const [airAiResults, setAirAiResults] = useState();
  const [deviations, setDeviations] = useState([]);
  const [totalAmount, setTotalAmount] = useState();
  const numIncidents = airAiResults ? airAiResults.length : 0;

  async function programQueryDetails() {
    const requestBody = { RN: entityNumber };
    try {
      setIsLoading(true);
      axios
        .post(
          API_BASE_URL + '/api/programQueryDetails',
          // 'http://localhost:5000/ceres-platform-test/us-central1/api/document-entity/list',
          requestBody,
          {
            headers: API_AUTH_HEADERS,
          }
        )
        .then((response) => {
          const detailsJson = response.data[0].get_prgm_json_for_entity;
          setDetails(detailsJson);
        })
        .catch((err) => {
          CeresLogger.error(err);
        })
        .finally(() => setIsLoading(false));
    } catch (e) {
      CeresLogger.error(e);
    }
  }

  const fetchAirAIRNStats = (value: any) => {
    try {
      axios
        .post(
          API_BASE_URL + '/api/fetchAirAIRNStats',
          // 'http://localhost:5000/ceres-platform-test/us-central1/api/fetchAirAIRNStats',
          { RN: value },
          {
            headers: API_AUTH_HEADERS,
          }
        )
        .then((response) => {
          if (response.data && response.data.length > 0) {
            const emissionEventsJson =
              typeof response.data[0].get_emission_events !== 'undefined' ? response.data[0].get_emission_events : [];
            setAirAiResults(emissionEventsJson);
            if(!emissionEventsJson.length) {
              toast.error(`No Emission events for ${entityNumber}`);
            }
            const total = emissionEventsJson.reduce((acc: number, item: any) => acc + item.amount, 0);
            setTotalAmount(total);
          }
        })
        .catch((err) => {
          CeresLogger.error(err);
        })
        .finally();
    } catch (e) {
      CeresLogger.error(e);
    }
  };

  const fetchDeviationRecords = () => {
    const requestBody = { RN: entityNumber };
    try {
      axios
        .post(
          API_BASE_URL + '/api/fetchDeviationRecords',
          // 'http://localhost:5000/ceres-platform-test/us-central1/api/fetchDeviationRecords',
          requestBody,
          {
            headers: API_AUTH_HEADERS,
          }
        )
        .then((response) => {
          const deviationsJson = response.data[0].aai_get_deviations_tab_json;
          setDeviations(deviationsJson);
          if(!deviationsJson.length) {
            toast.error(`No Deviations for ${entityNumber}`);
          }
        })
        .catch((err) => {
          CeresLogger.error(err);
        });
    } catch (e) {
      CeresLogger.error(e);
    }
  };

  useEffect(() => {
    async function fetchRecords() {
      let isSubscribed = true;
      const containsSearchTerm = await fetchRecordsByRN(entityNumber, props.currentQueryText, 'must');
      const data = containsSearchTerm.data as IElasticResult<ISearchRecord>;
      let relatedRecordsData;
      if (data.records.length < 50) {
        const containsSearchTermFalse = await fetchRecordsByRN(entityNumber, props.currentQueryText, 'must_not');
        const containsSearchTermFalseData = containsSearchTermFalse.data as IElasticResult<ISearchRecord>;
        relatedRecordsData = (containsSearchTermFalseData && containsSearchTermFalseData.records) || [];
      }
      let records = (data && data.records) || [];
      records.map((rec) => {
        rec.containsSearchTerm = true;
        return rec;
      });
      if (relatedRecordsData) {
        relatedRecordsData.map((rec) => {
          rec.containsSearchTerm = false;
          return rec;
        });
      }
      records = relatedRecordsData ? records.concat(relatedRecordsData) : records;
      records.sort((r1, r2) => (+new Date(r2.releaseDate) - +new Date(r1.releaseDate)));
      isSubscribed && setRelatedRecords(records);
      if(props.selectedRecordOption === 'Agency Documents' && !records.length) {
        toast.error(`No Agency Documents for ${entityNumber}`);
      }
      setIsLoading(false);
      return () => {
        isSubscribed = false;
      };
    }
    if (props.selectedRecordOption && props.selectedRecordOption.length > 0) {
      fetchRecords();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityNumber, props.currentQueryText, totalAmount, props.match.path]);
  useEffect(() => {
    if (props.selectedRecordOption && props.selectedRecordOption.length > 0) {
      programQueryDetails();
      fetchAirAIRNStats(entityNumber);
      fetchDeviationRecords();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[entityNumber]);
  return (
    <RecordMarkerContainer>
      {isMap && (
        <OverlayTrigger
          key={props.record.contentId}
          trigger={['hover', 'focus']}
          placement="bottom"
          delay={{ show: 200, hide: 1200 }}
          overlay={
            <ReactTooltip effect="solid" html={true} />
          }
        >
          <MarkerPin
            data-tip={
              ReactDOMServer.renderToString(
                <div>
                  <strong>{props.record.entityNumber}</strong>
              <br />
              {props.record.entityName}
              <br />
              {/* Program Symbol:{props.record.programSymbol} */}
              <IconPegman
                src="/icon/pegman.jpg"
                onClick={() => {
                  props.setStreetView(props.record.location);
                }}
              />
                </div>
              )
            }
            isActive={props.isActive ? '#336195' : '#005FBC'}
            $isWaterMode={props.isWaterMode}
            onClick={(e: any) => {
              props.onMarkerClick(props.record);
              e.stopPropagation();
            }}
          />
        </OverlayTrigger>
      )}
      {props.isActive && !isMap && (
        <>
          <AirAiSummary
            isActive={props.isActive}
            path={props.match.path}
            totalAmount={totalAmount}
            numIncidents={numIncidents}
            airEventTableOpen={props.airEventTableOpen}
            setAirEventTableOpen={props.setAirEventTableOpen}
          />
          {props.airEventTableOpen && <AirEventTable events={airAiResults} />}
          {!props.airEventTableOpen && props.selectedRecordOption !== '' && (
            <RecordMarkerInfoWindow
              routerProps={props}
              authContext={authContext}
              details={details}
              onInfoWindowClose={props.onInfoWindowClose}
              record={props.record}
              isLoading={isLoading}
              relatedRecords={relatedRecords}
              setShowDocPanel={props.setShowDocPanel}
              setRelatedDocument={props.setRelatedDocument}
              activeTabDrawer={props.activeTabDrawer}
              airAiResults={airAiResults}
              totalEvents={totalAmount}
              deviations={deviations}
              setDeviations={setDeviations}
              selectedRecordOption={props.selectedRecordOption}
              setIframeUrl={props.setIframeUrl}
              relatedRecordIndex={props.relatedRecordIndex}
            />
          )}
        </>
      )}
    </RecordMarkerContainer>
  );
};

export default withRouter(withAuthContext(MyTundraRecordMarker));
